import type { FC } from "react";
import { css } from "@stubhub/broadway-foundation/css";
import { Feature } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { gridWrapper } from "src/website-apps/responsive/stubhub-performer/components/alternative-performer-new-grid/styled-components";
import {
  AlternativePerformerCardSkeleton,
  CarouselTitleLoading,
  CarouselTitleSkeleton,
  LoadingAlternativePerformerCard,
} from "src/website-apps/shared/components/LoadingCarousel.styled";

/** Mobile-first: no grid on phone/tablet, grid layout on desktop only */
const fullWidthGrid = css({
  display: "grid",
  columnGap: "[38px]",
  rowGap: "primitives.300",
  desktop: {
    gridTemplateRows: "[72px]",
    gridTemplateColumns: "[repeat(auto-fill, minmax(350px, 1fr))]",
    gridAutoRows: "[72px]",
  },
});

interface Props {
  /** number of grid items */
  count?: number;
}

/**
 * Loading skeleton to show for the alternative performers grid carousel on performer page
 */
export const AlternativePerformerGridLoadingSkeleton: FC<Props> = ({ count = 6 }) => (
  <div>
    <Feature
      id={FeatureSetEnum.TMGlobalDSSkeleton}
      control={() => <CarouselTitleLoading />}
      variant={() => <CarouselTitleSkeleton />}
    />
    <div className={gridWrapper}>
      <div className={fullWidthGrid}>
        <Feature
          id={FeatureSetEnum.TMGlobalDSSkeleton}
          control={() => Array.from({ length: count }, (_, i) => <LoadingAlternativePerformerCard key={i} />)}
          variant={() => Array.from({ length: count }, (_, i) => <AlternativePerformerCardSkeleton key={i} />)}
        />
      </div>
    </div>
  </div>
);
